<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
export default {
    components: {},
    data: function () {
        return {
            discountPercent: 0,
            discountValue: 0,
            discountNote: '',
            isLoading: false,
        }
    },
    computed: {
        currentUser: function(){
            return this.$store.getters['auth/currentUser'];
        },
        currentTab: function(){
            return this.$store.getters['sale/currentTab'];
        },
    },
    methods: {
        ...urlMethods,
        percentChange(){
            var total_amount = this.currentTab.info.totalAmount;
            if(this.discountPercent > 100) this.discountPercent = 100;
            if(this.discountPercent < 0) this.discountPercent = 0;
            this.discountValue = this.discountPercent * (total_amount) / 100;
        },
        valueChange(){
            var total_amount = this.currentTab.info.totalAmount;
            if(this.discountValue > total_amount) this.discountValue = total_amount;
            if(this.discountValue < 0) this.discountValue = 0;
            if(total_amount > 0) this.discountPercent = Math.floor(this.discountValue * 100 / (total_amount));
        },
        setDiscountOther(e){
            e.preventDefault();
            try {
                if(this.discountNote.length < 5){
                    throw "Nội dung ghi chú quá ngắn";
                }
                this.$store.dispatch("sale/setDiscountOther",{'percent': this.discountPercent, 'value': this.discountValue, 'note': this.discountNote});
                this.$bvModal.hide('modal-discount-other');
            } catch (error) {
                let text = (typeof error  == 'string' ? error : JSON.stringify(error));
                this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
            }
            return false;
        },
    },
    mounted() {
        let that = this;
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'modal-discount-other'){
                setTimeout(() => {
                    if(typeof that.$refs.discountPercent != 'undefined' && typeof that.$refs.discountPercent.$el != 'undefined') that.$refs.discountPercent.$el.focus();
                }, 100);
            }
        });
    },
};
</script>

<template>
<b-modal id="modal-discount-other" title="Giảm khác" title-class="font-18" hide-footer>
    <form class="form-horizontal" @submit="setDiscountOther" role="form">
        <b-form-group class="mb-3" label-cols-lg="2" label="Phần trăm" label-for="discountPercent">
            <money class="form-control" @keyup.native="percentChange" ref="discountPercent" autocomplete="off" for="discountPercent" v-model="discountPercent"></money>
        </b-form-group>
        <b-form-group class="mb-3" label-cols-lg="2" label="Số tiền" label-for="discountValue" >
            <money class="form-control" @keyup.native="valueChange" ref="discountValue" autocomplete="off" for="discountValue" v-model="discountValue"></money>
        </b-form-group>
        <b-form-group class="mb-3" label-cols-lg="2" label="Ghi chú" label-for="discountNote" ><b-form-input type="text" ref="discountNote" autocomplete="off" for="discountNote" v-model="discountNote"></b-form-input></b-form-group>
        <div class="text-right"><b-button type="submit" variant="primary" ><i class="bx bx-check"></i> Xác nhận</b-button></div>
    </form>
</b-modal>
</template>
